import { defineComponent as _defineComponent } from 'vue'
import { ref, nextTick } from "vue";
  import LandingSection from "./LandingSection.vue";
  import BuilderDemo from "./BuilderDemo.vue";
  import {
    builderLandingSectionsData,
    builderLandingDocumentsData,
  } from "@/constants/landingData";
  import ContactUsLink from "./ContactUsLink.vue";
  import { useIsDesktop } from "@/features/useIsDesktop";
  import { scrollToElementIfNotVisible } from "@/helpers/scrollIfElementIsNotVisible";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuildersLanding',
  setup(__props, { expose: __expose }) {
  __expose();

  const showDocumentsItems = ref(false);

  const { isDesktop } = useIsDesktop();

  const onShowDocumentsItems = async () => {
    showDocumentsItems.value = !showDocumentsItems.value;

    if (!isDesktop.value) mobileScrollToDocumentsWrapper();
  };

  const mobileScrollToDocumentsWrapper = async () => {
    const DOCUMENTS_WRAPPER_SELECTOR = "#documents-wr";
    const BUILDER_MOBILE_HEADER_HEIGHT = 140;

    await nextTick(() =>
      scrollToElementIfNotVisible(
        DOCUMENTS_WRAPPER_SELECTOR,
        BUILDER_MOBILE_HEADER_HEIGHT
      )
    );
  };

const __returned__ = { showDocumentsItems, isDesktop, onShowDocumentsItems, mobileScrollToDocumentsWrapper, ref, nextTick, LandingSection, BuilderDemo, get builderLandingSectionsData() { return builderLandingSectionsData }, get builderLandingDocumentsData() { return builderLandingDocumentsData }, ContactUsLink, get useIsDesktop() { return useIsDesktop }, get scrollToElementIfNotVisible() { return scrollToElementIfNotVisible } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})